/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Load_ErrorInputs */

const vi_einvoice_credential_load_error = /** @type {(inputs: Einvoice_Credential_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa tải được trạng thái tài khoản MISA. Bạn có thể thử lại.`)
};

/**

* @param {Einvoice_Credential_Load_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_load_error = /** @type {((inputs?: Einvoice_Credential_Load_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Load_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_load_error(inputs)
});